import { Stack, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { z } from 'zod';

import { useTranslationPrefix } from 'infrastructure/translations/i18n';
import { TextField } from 'targets/web/components';
export const NotesSchema = z.object({
  notes: z.string().optional(),
});

export type NotesData = z.infer<typeof NotesSchema>;

export interface NotesProps {
  disabled?: boolean;
}

const TEXT_LIMIT = 250;

const NotesField: FC<NotesProps> = ({ disabled }) => {
  const { values, handleChange } = useFormikContext<NotesData>();
  const t = useTranslationPrefix('customer_portal.request_service_modal');
  return (
    <Stack spacing={4}>
      <TextField
        label={t('notes_label')}
        placeholder={t('notes_placeholder')}
        name="notes"
        value={values.notes}
        fullWidth
        multiline
        rows={4}
        disabled={disabled}
        onChange={handleChange('notes')}
        inputProps={{
          maxLength: TEXT_LIMIT,
        }}
      />
      <Typography variant="inputHelper">
        {t('notes_characters_remaining', { remaining: TEXT_LIMIT - (values.notes?.length ?? 0) })}
      </Typography>
    </Stack>
  );
};

export default NotesField;
